import { useAppSelector } from "app/hooks";

const useIsBlockPrinting = (id: number) => {
  const idPattern = `(\\d+,)*${id}(,\\d+)*`;

  const requestLoading = useAppSelector(
    (state) =>
      !!Object.entries(state.requestStatuses.loading)
        .find(([requestKey, _]) =>
          requestKey.match(new RegExp(`^blocks/print/${idPattern}$`))
        )
        ?.at(1)
  );

  const ajaxRequestLoading = useAppSelector(
    (state) => !!state.meta.blocks[id]?.printingCassette
  );

  return requestLoading || ajaxRequestLoading;
};

export default useIsBlockPrinting;
